<template>
    <van-nav-bar
    title="球局管理"
    left-text="返回"
    left-arrow
    @click-left="previousPage"
    />
</template>

<script>
export default {
// 
//   @click-right="onClickRight"
    methods:{
        previousPage(){
            this.$router.push({ name: 'gameList'})
        }
    }
}
</script>

<style>

</style>